import { render, staticRenderFns } from "./AddSeason.vue?vue&type=template&id=2c040f5c&scoped=true"
import script from "./AddSeason.vue?vue&type=script&lang=js"
export * from "./AddSeason.vue?vue&type=script&lang=js"
import style0 from "./AddSeason.vue?vue&type=style&index=0&id=2c040f5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c040f5c",
  null
  
)

export default component.exports